import React from "react";
import { classNames } from "../../../../helpers/classNames";
import useFetch from "../../../../hooks/useFetch";
import { dashboardCount } from "../../../../services/dashboardService";
import { formatNumber } from "../../../../helpers";

const DashboardCount = () => {
  const { data, error, isLoading, isFetching, refetch, updateData } = useFetch({
    dependencies: ["dashboard-count"],
    fetchFunction: async () => {
      return dashboardCount();
    },
  });

  const countData = [
    {
      title: "Total Scholarships",
      count: data?.data?.scholarshipCount || 0,
      bgClass: "bg-[#ecd4d5]",
    },
    {
      title: "Total Applications",
      count: data?.data?.scholarshipApplicationsCount || 0,
      bgClass: "bg-[#C9CDCE]",
    },
    {
      title: "Total Funds",
      count: `$${formatNumber(data?.data?.totalFunds || 0) || 0}`,
      bgClass: "bg-[#D3C8C8]",
    },
    {
      title: "Total Awarded",
      count: `${formatNumber(data?.data?.totalAwarded || 0) || 0}`,
      bgClass: "bg-[#ecd4d5]",
    },
    {
      title: "Total Donation",
      count: `$${formatNumber(data?.data?.totalDonation || 0) || 0}`,
      bgClass: "bg-[#C9CDCE]",
    },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-2 lg:gap-4">
      {countData?.map((item, i) => (
        <div
          key={i?.toString()}
          className={classNames(
            "w-full aspect-[3/2] rounded-lg h-full flex flex-col items-center justify-center py-4 px-4 space-y-2 lg:space-y-4 ",
            item?.bgClass
          )}
          style={item?.bg && { background: item?.bg }}
        >
          <div className="text-3xl lg:text-4xl 1xl:text-5xl font-bold text-center font-CanelaDeck">
            {item?.count}
          </div>
          <div className="text-[0.7rem] lg:text-base 1xl:text-lg xl:text-2xl font-bold text-center font-CanelaDeck">
            {item?.title}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardCount;
